import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { debounceTime, filter, retry } from 'rxjs/operators'
import { OfferModelData } from '../../models/offer.model'
import { OffersService } from '../../services/offers.service'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { MatSelect } from '@angular/material/select'

@Component({
	selector: 'app-add-promo-code-country-price',
	templateUrl: './add-promo-code-country-price.component.html',
	styleUrls: ['./add-promo-code-country-price.component.scss'],
})
export class AddPromoCodeCountryPriceComponent implements OnInit {
	@Input() offerData!: OfferModelData
	@Input() isAddMode: boolean = false
	@Input() editMode: boolean = false
	@Output() dataChanged: EventEmitter<any> = new EventEmitter()
	@ViewChild('selector', { static: false }) selector!: MatSelect
	offerForm: FormGroup = new FormGroup({})
	showList = false
	serviceProviders: any = []
	serviceProvidersSelected: any = []
	subscription = new Subscription()
	keyWord = new FormControl('')
	oldValues = null
	isChanged = false
	fixedMethod = false
	perMethod = false
	selectFormControl = new FormControl()
	offerFilter: any = {
		searchText: '',
		countryId: 0,
	}
	constructor(
		public translate: TranslateService,
		private offerService: OffersService,
		private toaster: ToastrService,
		private dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.keyWord.valueChanges
			.pipe(
				filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
				debounceTime(700),
				retry(-1)
			)
			.subscribe((res: any) => {
				this.getServiceProviders()
			})
	}
	ngOnChanges() {
		this.initForm()
		console.log(this.offerForm?.controls)
	}

	initForm() {
		this.offerForm = new FormGroup({
			// id: new FormControl(this.branchInformationData?.id),
			countryId: new FormControl(
				{
					value: this.offerData?.country?.id,
					disabled: this.offerData?.appointmentsCount ? true : false,
				},
				[Validators.required]
			),
			offerMethod: new FormControl(this.offerData?.offerMethod, [
				Validators.required,
			]),
			fixedAmount: new FormControl(
				this.offerData?.fixedAmount ? this.offerData?.fixedAmount : null,
				[Validators.min(1), Validators.pattern(/^[0-9]\d*$/)]
			),
			fixedMinValue: new FormControl(this.offerData?.fixedMinValue, [
				Validators.pattern(/^[0-9]\d*$/),
			]),
			percentage: new FormControl(
				this.offerData?.percentage ? this.offerData?.percentage : null,
				[Validators.pattern('^(?=[0-9.])[0-9]{0,2}$|^100$'), Validators.min(1)]
			),
			percentageDiscountAmountUpTo: new FormControl(
				this.offerData?.percentageDiscountAmountUpTo,
				[Validators.min(1)]
			),
			isForAllProviders: new FormControl(
				this.offerData?.isForAllProviders == undefined
					? true
					: this.offerData?.isForAllProviders
			),
			offerServiceProviders: new FormControl(
				this.offerData?.offerServiceProviders || []
			),
			clientVisibility: new FormControl(this.offerData?.clientVisibility),
		})
		if (
			this.editMode &&
			this.getController('isForAllProviders').value == false
		) {
			this.getServiceProviders()
		}
		this.oldValues = this.offerForm.getRawValue()

		this.subscription.add(
			this.offerForm.valueChanges.subscribe((res) => {
				this.isChanged = JSON.stringify(this.oldValues) != JSON.stringify(res)
				this.dataChanged.emit({ value: res, isInvalid: this.offerForm.invalid })
			})
		)
	}

	openDialog() {
		if (this.offerData?.appointmentsCount > 0) {
			this.dialog
				.open(ConfirmationMessageComponent, {
					width: '385px',
					// height: '340px',
					data: {
						notflex: true,
						image: 'assets/images/Frame.svg',
						message: 'CONFIRMATION_MESSAGE.ARE_YOU_SURE_TO_DELETE_SP',
						cancelBtn: 'ACTIONS.NO',
						confirmBtn: 'ACTIONS.YES',
					},
				})
				.afterClosed()
				.subscribe({
					next: (res) => {
						if (res) {
							this.updateData()
						}
					},
				})
		}
		// this.updateData()
	}

	changeEditMode() {
		this.editMode = !this.editMode
		this.initForm()
		if (this.offerData?.appointmentsCount > 0) {
			this.getController('offerMethod').disable()
			this.getController('fixedAmount').disable()
			this.getController('fixedMinValue').disable()
			this.getController('percentage').disable()
			this.getController('percentageDiscountAmountUpTo').disable()
		}
	}

	offerTypeChanged() {
		if (this.getController('isForAllProviders')?.value == false) {
			this.getController('offerServiceProviders').addValidators(
				Validators.required
			)
			this.getController('offerServiceProviders').updateValueAndValidity()
		} else {
			this.getController('offerServiceProviders').removeValidators(
				Validators.required
			)
			this.getController('offerServiceProviders').updateValueAndValidity()
		}
	}

	getServiceProviders() {
		this.getController('countryId').value == 224
			? (this.offerFilter.countryId = 224)
			: this.getController('countryId').value == 103
			? (this.offerFilter.countryId = 103)
			: null

		this.offerFilter.searchText = this.keyWord.value
		this.subscription.add(
			this.offerService
				.SearchServiceProviders(this.offerFilter)
				.subscribe((res: any) => {
					this.serviceProviders = [
						...res?.result?.items,
						...this.getController('offerServiceProviders')?.value,
					]
				})
		)
	}

	validateInput(event: any) {
		const inputValue = event.key
		const numberRegex = /^[0-9.-]$/

		if (!numberRegex.test(inputValue)) {
			event.preventDefault()
		}
	}

	fixedMethodChanged() {
		if (this.getController('offerMethod')?.value == 0) {
			this.getController('fixedAmount').addValidators([
				Validators.required,
				Validators.min(1),
				Validators.pattern(/^[0-9]\d*$/),
			])
			this.getController('fixedAmount').updateValueAndValidity()
			this.getController('percentage').clearValidators()
			this.getController('percentage').updateValueAndValidity()
		} else {
			this.getController('percentage').addValidators([
				Validators.required,
				Validators.pattern('^(?=[0-9.])[0-9]{0,2}$|^100$'),
				Validators.min(1),
			])
			this.getController('percentage').updateValueAndValidity()
			this.getController('fixedAmount').clearValidators()
			this.getController('fixedAmount').updateValueAndValidity()
		}
	}

	updateData() {
		const Body = {
			id: this.offerData.id,
			countryId: this.offerData?.country?.id,
			...this.offerForm.getRawValue(),
		}
		this.subscription.add(
			this.offerService
				.updatePromoCodeCountryAndPricing(Body)
				.subscribe((res) => {
					this.offerData = { ...this.offerData, ...Body }
					this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
					this.editMode = false
					this.dataChanged.emit()
				})
		)
	}

	compareWith(a: any, b: any) {
		return a?.id == b?.id
	}

	deleteServiceProvider(sp: any) {
		const spValue = [...this.getController('offerServiceProviders').value]
		const index = spValue.findIndex((provider: any) => provider.id == sp.id)
		spValue.splice(index, 1)
		this.getController('offerServiceProviders').setValue(spValue)
		this.serviceProvidersSelected = [...spValue]

		if (this.getController('offerServiceProviders').value.length == 0) {
			this.getController('isForAllProviders').setValue(true)
		}
	}

	getController(controlName: string) {
		return this.offerForm.controls[controlName]
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
